// Which olympiad this form registers for. Everything that changes per year comes from the
// backend (season settings in the admin panel); this file is the only per-app difference.
const OLYMPIAD = {
  app: "physics",
  submitPath: "/adding_data_req_physics",
};

export default OLYMPIAD;
